import { render, staticRenderFns } from "./eventoFormForm.vue?vue&type=template&id=80585fbc"
import script from "./eventoFormForm.vue?vue&type=script&lang=js"
export * from "./eventoFormForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports